export default "__VITE_ASSET__3a28ad53__"